import { z } from "zod/v4";
import { QuotesIdSchema } from "./PecDocumentsSchemas.js";
export const QuoteTrackingStateSchema = z.enum([
    "created",
    "given",
    "accepted",
    "invalid",
    "refused",
    "abandoned",
    "performed_without_acceptance",
]);
export const quoteTrackingLabels = {
    created: "Créé",
    given: "Remis",
    accepted: "Accepté",
    invalid: "Invalide",
    refused: "Refusé",
    abandoned: "Abandonné",
    performed_without_acceptance: "Réalisé sans acceptation",
};
export function normalizeQuoteTrackingState(state) {
    return state === "staging" ? "created" : state;
}
export const QuoteStatusHistoryEntrySchema = z.object({
    previousState: QuoteTrackingStateSchema,
    state: QuoteTrackingStateSchema,
    effectiveDate: z.iso.date().nullable(),
    recordedAt: z.iso.datetime(),
    actorId: z.string(),
    previousDeliveryDate: z.iso.date().nullable(),
    deliveryDate: z.iso.date().nullable(),
    previousAcceptanceDate: z.iso.date().nullable(),
    acceptanceDate: z.iso.date().nullable(),
});
export const QuoteStatusHistorySchema = z.array(QuoteStatusHistoryEntrySchema);
export const QuoteTrackingSchema = z.object({
    state: QuoteTrackingStateSchema,
    deliveryDate: z.iso.date().nullable(),
    acceptanceDate: z.iso.date().nullable(),
    history: QuoteStatusHistorySchema,
});
export const QuoteRealizationLineSchema = z.object({
    lineId: z.string(),
    description: z.string(),
    ccamCode: z.string().nullable(),
    teeth: z.array(z.string()),
    state: z.enum(["performed", "not_found", "ambiguous", "unverifiable"]),
    acteId: z.string().nullable(),
    performedDate: z.iso.date().nullable(),
    competingQuoteIds: z.array(z.string()),
});
export const QuoteRealizationSchema = z.object({
    state: z.enum([
        "none",
        "partial",
        "performed",
        "ambiguous",
        "unverifiable",
        "excluded",
    ]),
    totalLines: z.number().int().nonnegative(),
    performedLines: z.number().int().nonnegative(),
    totalPerformedFees: z.string().optional(),
    ambiguousLines: z.number().int().nonnegative(),
    unverifiableLines: z.number().int().nonnegative(),
    completionDate: z.iso.date().nullable(),
    withoutRecordedAcceptance: z.boolean(),
    lines: z.array(QuoteRealizationLineSchema),
});
export const UpdateQuoteTrackingInputSchema = z.object({
    quoteId: QuotesIdSchema,
    state: QuoteTrackingStateSchema,
    effectiveDate: z.iso.date().nullable(),
    deliveryDate: z.iso.date().nullable(),
    acceptanceDate: z.iso.date().nullable(),
    expectedHistoryLength: z.number().int().nonnegative(),
});
export const QuoteTrackingSortColumnSchema = z.enum([
    "patient",
    "name",
    "creationDate",
    "totalFees",
    "totalPerformedFees",
    "state",
]);
export const ListQuoteTrackingInputSchema = z
    .object({
    search: z.string().trim().max(200).default(""),
    state: QuoteTrackingStateSchema.optional(),
    from: z.iso.date().optional(),
    to: z.iso.date().optional(),
    sort: z.enum(["oldest", "newest"]).default("oldest"),
    sortBy: QuoteTrackingSortColumnSchema.default("creationDate"),
    sortDirection: z.enum(["asc", "desc"]).optional(),
    page: z.number().int().nonnegative().default(0),
})
    .refine((input) => !input.from || !input.to || input.from <= input.to, {
    message: "La date de début doit précéder la date de fin.",
    path: ["to"],
});
//# sourceMappingURL=QuoteTrackingSchemas.js.map